/**
 * Mock data generators for Account Security Dashboard
 */

export const generateMockSecurityData = (user) => ({
  mfa_enabled: user?.mfa_enabled || false,
  password_last_changed: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
  password_strength: 'strong',
  last_login: new Date().toISOString(),
  total_logins_30d: 15,
  failed_login_attempts: 0,
  account_created: user?.created_at || new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString(),
  security_score: user?.mfa_enabled ? 95 : 70
});

export const generateMockLoginHistory = () => [
  {
    id: '1',
    timestamp: new Date().toISOString(),
    ip_address: '103.45.xxx.xxx',
    location: 'Dubai, UAE',
    device: 'Chrome on Windows',
    status: 'success',
    is_current: true
  },
  {
    id: '2',
    timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    ip_address: '103.45.xxx.xxx',
    location: 'Dubai, UAE',
    device: 'Safari on iPhone',
    status: 'success',
    is_current: false
  },
  {
    id: '3',
    timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    ip_address: '103.45.xxx.xxx',
    location: 'Dubai, UAE',
    device: 'Chrome on MacOS',
    status: 'success',
    is_current: false
  },
  {
    id: '4',
    timestamp: new Date(Date.now() - 48 * 60 * 60 * 1000).toISOString(),
    ip_address: '192.168.xxx.xxx',
    location: 'Unknown',
    device: 'Firefox on Linux',
    status: 'failed',
    is_current: false
  }
];

export const generateMockSessions = () => [
  {
    id: 'current',
    device: 'Chrome on Windows',
    device_type: 'desktop',
    ip_address: '103.45.xxx.xxx',
    location: 'Dubai, UAE',
    last_active: new Date().toISOString(),
    is_current: true
  },
  {
    id: 'mobile1',
    device: 'Safari on iPhone',
    device_type: 'mobile',
    ip_address: '103.45.xxx.xxx',
    location: 'Dubai, UAE',
    last_active: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
    is_current: false
  }
];

export const formatTimeAgo = (timestamp) => {
  const diff = Date.now() - new Date(timestamp).getTime();
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);

  if (minutes < 1) return 'Just now';
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  return `${days}d ago`;
};

export const getSecurityScore = (securityData) => {
  let score = 50;
  if (securityData?.mfa_enabled) score += 30;
  if (securityData?.password_strength === 'strong') score += 20;
  return Math.min(100, score);
};

export const getScoreColor = (score) => {
  if (score >= 80) return 'text-green-600 bg-green-50 border-green-200';
  if (score >= 60) return 'text-amber-600 bg-amber-50 border-amber-200';
  return 'text-red-600 bg-red-50 border-red-200';
};
